export const activePrinciples: string[] = [
  'acamprosato',
  'agomelatina',
  'aloperidolo',
  'alprazolam',
  'amisulpride',
  'amitriptilina',
  'amoxapina',
  'armodafinil',
  'aripiprazolo',
  'asenapina',
  'atomoxetina',
  'brexpiprazolo',
  'bromazepam',
  'bupoprione',
  'buspirone',
  'carbamazepin',
  'cariprazina',
  'ciamemazina',
  'citalopram',
  'clomipramina',
  'clonazepam',
  'clonidina',
  'clorazepato',
  'clordiazepossido',
  'clorpromazina',
  'clozapina',
  'delorazepam',
  'desipramina',
  'desvenlafaxina',
  'diazepam',
  'dotiepina',
  'doxepina',
  'duloxetina',
  'escitalopram',
  'esketamina',
  'fenelzina',
  'flufenazina',
  'fluoxetina',
  'flupentixolo',
  'flurazepam',
  'fluvoxamina',
  'gabapentin',
  'idrossizina',
  'imipramina',
  'isocarbossazide',
  'lamotrigina',
  'levetiracetam',
  'litio',
  'lofepramina',
  'loflazepato',
  'loxapina',
  'lorazepam',
  'lormetazepam',
  'lurasidone',
  'memantina',
  'D-metilfenidato',
  'D,L-metilfenidato',
  'midazolam',
  'mirtazapina',
  'moclobemide',
  'modafinil',
  'naltrexone',
  'nefazodone',
  'nortripitilina',
  'olanzapina',
  'oxazepam',
  'oxcarbazepina',
  'paliperidone',
  'paroxetina',
  'perfenazina',
  'pipotiazina',
  'prazosina',
  'pregabalin',
  'propranololo',
  'protiptilina',
  'quetiapina',
  'reboxetina',
  'risperidone',
  'selegina',
  'sertralina',
  'sildenafil',
  'sulpiride',
  'tiotixene',
  'topiramato',
  'trazodone',
  'triazolam',
  'trifluoperazina',
  'trimipramina',
  'venlafaxina',
  'valproato',
  'vilazodone',
  'vortioxetina',
  'zaleplon',
  'zolpidem',
  'zopiclone',
  'ziprasidone',
  'zotepina',
  'zuclopentixolo',
];

export const documentsCategories: string[] = [
  'Modulistica',
  'Testistica',
  'Didattica',
  'Altro',
  'Tutte le categorie',
];

export const documentsCategoriesForNewModule: string[] = [
  'Modulistica',
  'Testistica',
  'Didattica',
  'Altro',
];
